import { useQuery } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';
import { useOrgId } from '@/app/session';
import { providersQuery } from './drafts';

export type AiAvailability = { state: 'loading' } | { state: 'ready'; providerId: string } | { state: 'missing' };

/** Whether "Draft with AI" can run: an enabled model provider with a credential. */
export function useAi(): AiAvailability {
  const orgId = useOrgId();
  const providers = useQuery(providersQuery(orgId));
  if (providers.isPending) return { state: 'loading' };
  const first = providers.data?.[0];
  return first ? { state: 'ready', providerId: first.id } : { state: 'missing' };
}

/** No model provider: the state and the way to fix it. */
export function AiMissing() {
  return (
    <p className="ai-missing" role="status">
      No AI provider. <Link to="/app/settings/ai">Set up AI provider</Link>
    </p>
  );
}
